'use strict';
'use client';
import { j as l } from "../../external/react/jsx-runtime.js";
import n from "../../external/classnames/index.js";
import { useTheme as h } from "../Provider/index.js";
import { FontAwesomeIcon as g } from "../../external/@fortawesome/react-fontawesome/index.es.js";
const j = ({
  className: x,
  as: p,
  text: u,
  variant: r = "default",
  size: s = "regular",
  rounded: i = !0,
  children: b,
  icon: a,
  iconLeft: d = !1,
  ...m
}) => {
  const c = p || "div", { isMosh: e, isMoshy: t } = h(), o = {
    default: {
      container: "bg-grey-200 text-grey-400 border-transparent border-2",
      text: "text-grey-400"
    },
    "outline-dark": {
      container: n("bg-transparent border", {
        "border-purple-dark": t,
        "border-green-dark": e
      }),
      text: {
        "text-purple-dark": t,
        "text-green-dark": e
      }
    },
    "outline-light": {
      container: "bg-transparent border border-white",
      text: "text-white"
    },
    "fill-dark": {
      container: {
        "bg-purple-dark": t,
        "bg-green-dark": e
      },
      text: "text-white"
    },
    "fill-light": {
      container: "bg-white",
      text: {
        "text-purple-dark": t,
        "text-green-dark": e
      }
    },
    "tag-medium": {
      container: n("border-transparent", {
        "bg-purple-light": t,
        "bg-green-light": e
      }),
      text: {
        "text-purple-dark": t,
        "text-green-dark": e
      }
    },
    highlight: {
      container: {
        "bg-blue": t,
        "bg-green": e
      },
      text: {
        "text-white": t,
        "text-green-dark": e
      }
    },
    warning: {
      container: "bg-yellow-warning",
      text: "text-brown"
    },
    success: {
      container: "bg-green-success-dark",
      text: "text-green-dark"
    },
    error: {
      container: "bg-red-error",
      text: "text-white"
    }
  };
  return /* @__PURE__ */ l.jsxs(
    c,
    {
      className: n(
        "whitespace-nowrap font-demi transition-all duration-200 ease-in-out border-solid px-3 py-2",
        {
          "text-[16px] leading-none": s === "small",
          "text-base": s === "regular",
          "rounded-full": i,
          "rounded-lg": !i
        },
        o[r].container,
        o[r].text,
        x
      ),
      "data-size": s,
      "data-variant": r,
      ...m,
      children: [
        a && d ? /* @__PURE__ */ l.jsx(
          g,
          {
            icon: a,
            size: "sm",
            className: n("mr-2", o[r].text)
          }
        ) : null,
        u,
        b,
        a && !d ? /* @__PURE__ */ l.jsx(
          g,
          {
            icon: a,
            size: "sm",
            className: n("ml-2 ", o[r].text)
          }
        ) : null
      ]
    }
  );
};
export {
  j as default
};
